import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// import { Auth0Provider } from '@auth0/auth0-react';
//auth0 for authentication
const domain = "dev-yf1egxsagqcgc4hg.us.auth0.com";
const clientId = "TGxFyUOXw2WcZn9bj1PWAp2y6ncANIpe";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <Auth0Provider
  //   domain={domain}
  //   clientId={clientId}
  //   authorizationParams={{
  //     redirect_uri: window.location.origin
  //   }}
  // >
    <App />
  // </Auth0Provider>
);

